// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rocketBlue{width:60px;height:60px}.modal-header,.modal-footer{border:none}.modal-footer{margin-right:10px}.modal-body{padding:0 30px 20px 30px}.modal-dialog{max-width:550px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
